<div class="dialog">
  <app-image-cropper [source]="sourceImage" (cropChanged)="handleCropChanged($event)"></app-image-cropper>

  <div class="button-group">
    <button trans="account.logout_dialog.cancel" class="btn btn-secondary" (click)="cancel()"></button>
    <button trans="account.delete.button" class="btn btn-primary" (click)="submit()"></button>
  </div>
</div>
